import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TipoAerovale } from '@shared/enums/tipoAerovale';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-seleccion-tipo-aerovale',
  templateUrl: './seleccion-tipo-aerovale.component.html',
  styleUrls: ['./seleccion-tipo-aerovale.component.css']
})
export class SeleccionTipoAerovaleComponent {

  enumTipoAerovale = TipoAerovale;

  constructor(public activeModal: NgbActiveModal, public authService: AuthService) { }

  rolesFacturacionAnticipada() {
    return this.authService.hasRole(TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV);
  }

  onTipoAerovaleSeleccionado(tipoAerovale: TipoAerovale) {
    this.activeModal.close(tipoAerovale);
  }

}
